const pickUpLabelText = { id: 'pickUpLabel.textLabel' }

const textIds = {
  pickUpLabelText,
}

export default textIds
